module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"client":"客户","honor":"荣誉","download_artist_intro":"下载艺术家介绍"},"en":{"client":"Client","honor":"Honors and Awards","download_artist_intro":"Download Artist Introduction"}}')
  delete Component.options._Ctor
}
